<ng-container *ngIf="resourceType !== 'SERVICEPROVIDER' && resourceType !== 'SERVICEDISTRIBUTOR'; else serviceSpecificTemplate">
    <div>
        <div >
            <!-- <div class="approveContent">
                <span>
                    {{ title }}
                </span>
            </div> -->

            <div>
                <span class="approveContent">
                    <!-- {{ message }} -->
                    Once you Approve, the application will be moved to the  Approved queue.
                    Are you sure to  Approve the application? 
                </span>
                <!-- <div class="flex justify-content-start flex-wrap" *ngFor="let detail of details">
                    <div class="flex align-items-center justify-content-center m-2">
                        <i class="pi pi-circle-fill" style="font-size: 6px;"></i>
                    </div>
                    <div class="flex align-items-center justify-content-center m-2">
                        <span [innerHTML]="detail"></span>
                    </div>
                </div> -->
            </div>
            <div style="margin-top: 32px;">
                <div class="flex justify-content-end flex-wrap">
                    <div class="flex align-items-center justify-content-center m-2">
                        <button class="btn btn-cancel btn-1 " pButton
                            (click)="closeDialog()">Cancel</button>
                    </div>
                    <div class="flex align-items-center justify-content-center m-2">
                        <button class="btn-1 small raised btn-primary" pButton
                         (click)="approve()">Approve</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<!-- Template for Service Provider Dialog -->
<ng-template #serviceSpecificTemplate>
    <ng-container *ngIf="resourceType === 'SERVICEPROVIDER'; else serviceDistributorTemplate">
        <div class="dialog-container">
            <!-- <div class="dialog-header">
                <span class="dialog-title">Approve service provider application?</span>
            </div>
     -->
            <div class="dialog-body">
                <p class="dialog-message">Once you approve,</p>
                <ul class="dialog-details">
                    <li class="dialog-detail-item">
                        <i class="pi pi-circle-fill dialog-icon" style="font-size: 6px;"></i>
                        <span class="dialog-detail-text">The service provider application will be moved to the
                        Approved queue.</span>
                    </li>
                    <li class="dialog-detail-item">
                        <i class="pi pi-circle-fill dialog-icon" style="font-size: 6px;"></i>
                        <span class="dialog-detail-text">
                            Once approved, you will be provided
                            <input type="text" [(ngModel)]="subdomain" class="subdomain-input" />
                            .autoecare.com
                        </span>
                    </li>
                </ul>
            </div>
    
            <div class="dialog-footer">
                <button class="btn btn-cancel btn-1" pButton
                 [disabled]="isApproved" (click)="closeDialog()">Cancel</button>
                <button class="btn btn-approve btn-primary" pButton
                 [disabled]="isApproved" (click)="approve()">Approve</button>
            </div>
        </div>
    </ng-container>
    
</ng-template>

<ng-template #serviceDistributorTemplate>
    <div>
        <!-- <div class="dialog-header">
            <span class="dialog-title">Approve service distributor application?</span>
        </div> -->

        <div class="dialog-body">
            <p class="dialog-message">Once you approve,</p>
            <ul class="dialog-details">
                <li class="dialog-detail-item">
                    <i class="pi pi-circle-fill dialog-icon"style="font-size: 6px;"></i>
                    <span class="dialog-detail-text">
                        The distributor application will be moved to the Approved queue.
                    </span>
                </li>
                <li class="dialog-detail-item">
                    <i class="pi pi-circle-fill dialog-icon" style="font-size: 6px;"></i>
                    <span class="dialog-detail-text">
                        The uploaded document will be stored in your and the distributor's E-locker.
                    </span>
                </li>
            </ul>

            <div class="file-upload-container">
                <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
            </div>
        </div>

        <div class="dialog-footer">
            <button class="btn btn-cancel btn-1" pButton
             (click)="closeDialog()">Cancel</button>
            <button class="btn btn-approve btn-primary" pButton
             [disabled]="isApproved || !model.agreementFiles?.length" (click)="approve()">Approve</button>
        </div>
    </div>
</ng-template>